import { useEffect, useContext, useState, forwardRef } from "react";

import
{

  BannerContainer,
  AddonsGridPanel
} from "./AddOns.styles";
import { getBillingRedirect } from "../../../api";
import CustomTabGroup from "../../../components/Inputs/CustomTabGroup/CustomTabGroup";

import MainWrapper from "../../../components/Wrappers/MainWrapper/MainWrapper";
import Title from "../../../components/Typography/Title/Title";
import Banner from "../../../components/Alerts/Banner/Banner";
import Grid from '@mui/material/Unstable_Grid2';


// Contexts
import { BaseContext } from "../../../providers/Global/BaseProvider";
import { LicencesContext } from "../../../providers/Index/AddonsProvider";

import AddonDescriptionCard from "../../../components/Cards/AddonDescriptionCard/AddonDescriptionCard";
import { routes } from "../../../options/routes";
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Slide, useMediaQuery } from "@mui/material";
import AddonCard from "../../../components/Cards/AddonCard/AddonCard";

import { addonOptions, addonTabs, getOptionByName } from "../../../options/addonOptions";
import { useParams } from "react-router-dom/cjs/react-router-dom";
import OutlinedButton from "../../../components/Buttons/OutlinedButton/OutlinedButton";
import SectionSpinner from "../../../components/Loading/SectionSpinner/SectionSpinner";
import { updateUrl } from "../../../utils/helpers/urlHelpers";
import { getManageClubId } from "../../../utils/helpers/clubHelper";
// API Calls

const Transition = forwardRef(function Transition(props, ref)
{
  return <Slide direction="up" ref={ref} {...props} />;
});
const Addons = () =>
{
  const params = useParams();
  const [addonDetails, setAddonDetails] = useState([]);
  const [selectedTab, setSelectedTab] = useState('individual');
  const baseContext = useContext(BaseContext);
  const licencesContext = useContext(LicencesContext);

  const [dataLoading, setDataLoading] = useState(true);
  const [activeLicences, setActiveLicences] = useState([]);
  const [selectedAddon, setSelectedAddon] = useState("");

  const [bannerError] = useState("");
  const [redirectLoading, setRedirectLoading] = useState(false);
  const [open, setOpen] = useState(false);

  const [error, setError] = useState({
    show: false,
    message: "",
  });


  const handleTabChange = async (id) =>
  {
    setSelectedTab(id);
    if (addonDetails[selectedAddon.id].type !== id)
    {
      let newSelectedAddon = addonDetails.find((a) => a.type === id);
      setSelectedAddon(newSelectedAddon);
      updateUrl(routes.indexAddOns, [newSelectedAddon.name]);
    }
  }

  const handleUpdateClick = () =>
  {
    setOpen(false);

  };
  const handleClose = () =>
  {
    setOpen(false);
  };
  const isWide = useMediaQuery((theme) => theme.breakpoints.up('sm'));
  const descriptionPanel = useMediaQuery((theme) => theme.breakpoints.up('sm'));
  const handleSubscribleClick = (event, name) =>
  {
    //onSubscribeClick(event, a.id, name)

    setOpen(true);

  };
  useEffect(() =>
  {
    setDataLoading(false);
    if (
      !baseContext.baseData.loading

    )
    {
      setDataLoading(false);
      setAddonDetails(addonOptions);

      let addonName = '';
      if (params.addon)
      {
        addonName = params.addon;
      } else
      {
        addonName = addonOptions[0].name;
        updateUrl(routes.indexAddOns, [addonName])
      }

      let option = getOptionByName(addonName);
      if (option)
      {
        setSelectedAddon(option);
        setSelectedTab(option.type);
      }

      if (params.errorstate)
      {
        switch (params.errorstate)
        {
          case 'success': setError({
            show: false,
            message: "Subscription successful",
          });

            break;
          case 'cancelled':
            setError({
              show: true,
              message: "Subscription Process was cancelled",
            }); break;
          case 'error':
            setError({
              show: true,
              message: "There was an error subscribing",
            });
            break;
          default:
        }
        window.history.replaceState(null, "", routes.indexAddOns);


      }
      let activeAddons = [];

      baseContext.baseData.licences.forEach(element =>
      {
        if (element.type === 'ADDON')
        {
          activeAddons.push(element.code)
        }

      });
      setActiveLicences(activeAddons);
      /* 
       const date = new Date();
       setActiveLicenceExpiry(new Date(date.setDate(date.getDate() + 30)));
       
     } if (
       
       licencesContext?.licencesData &&
       !licencesContext?.licencesData?.loading
     )
     {
       
       setLicenceDetails(licencesContext.licencesData.licences      );  */
    }

  }, [baseContext, licencesContext, params]);

  const onSubscribeClick = async (event, item, freq) =>
  {
    if (!item) return;
    //setSelectedAddon(id)
    console.log(`subscribe ${event} ${item} ${freq}`);

    let response;
    let billingParams = {
      success_url: document.location.href + "/success",
      cancel_url: document.location.href + "/cancelled",
    };

    let clubId = await getManageClubId();
    if (clubId)
    {
      billingParams['club_id'] = clubId;
    }
    //setSelectedLicence(type);
    //params.subscription = (freq === "monthly") ? "monthlyClubSub" : "annualClubSub";
    billingParams.subscription = item;
    billingParams.subscription += (freq === "monthly") ? "_month" : "_year";
    //billingParams.success_url += "?success=" + billingParams.subscription;
    setRedirectLoading(freq);
    response = await getBillingRedirect(billingParams);


    //    document.location = response.data.url;
    console.log(`redirecting: ${response.data.url}`)

    if (response.data?.url)
    {
      console.log(`redirecting: ${response.data.url}`)
      document.location.href = response.data.url
    }
    if (response)
    {
      /*       setError({
              show: true,
              message: "Please choose a valid subscription type",
            }); */
    } else
    {
      setError({
        show: true,
        message: "Error getting product",
      });
    }
  }
  const OnCardClick = async (event, id) =>
  {
    //event.preventDefault();
    //setSelectedAddon(id)
    let currentCard = selectedAddon;
    if (selectedAddon.id === id) return;
    let regex = new RegExp(selectedAddon.name);

    let addon = null;
    for (let i = 0; i < addonDetails.length; i++)
    {
      if (addonDetails[i].id == id)
      {
        addon = addonDetails[i];
        break;
      }
    }

    let newUrl = routes.indexAddOns + '/' + addon.name;
    window.history.replaceState(null, "", newUrl)
    console.log(id);
    console.log(event);
    setSelectedAddon(addon);
  }
  return (
    <>
      {
        <MainWrapper
          error={error.show}
          apiMessage={error.message}
          activeRoute={routes.indexAddOns}
          clubLogo={baseContext.baseData.clubProfile.logo}
          dataLoading={dataLoading}
          hasEliteLicence={baseContext.baseData.hasEliteLicence}
          hasRezzilPlayerLicence={baseContext.baseData.hasRezzilPlayerLicence}
          licences={baseContext.baseData.licences}
        >
          <Title text={"Add-ons"} />
          {bannerError && (
            <BannerContainer>
              <Banner open={bannerError} text={bannerError} />
            </BannerContainer>
          )}
          <CustomTabGroup
            options={addonTabs}
            value={selectedTab}
            onChange={handleTabChange}
          />
          {
            <>
              <br />
              <Grid container spacing={0} columns={12}>
                <Grid id="options" xs={12} sm={4} lg={6}>

                  <Grid id="items" container spacing={4} columns={12}>

                    {
                      addonDetails.length > 0 &&
                      addonDetails.map((a) => (
                        a.type == selectedTab &&
                        <Grid sm={12} lg={6}>
                          <AddonCard
                            details={a}
                            key={a.id}
                            name={a.name}
                            description={a.description}
                            title={a.title}
                            image={a.image}
                            isSelected={(a.id === selectedAddon.id)}
                            isWide={a.isWide}
                            showDetails={!descriptionPanel}
                            isActive={activeLicences.indexOf(a.name) !== -1}
                            onClick={(event) => { OnCardClick(event, a.id, a.name) }}
                            onSubscribeClick={(event, name) => onSubscribeClick(event, a.id, name)}
                          />
                        </Grid>
                      ))
                    }
                  </Grid>
                </Grid>

                {descriptionPanel &&
                  <Grid id="desc" xs={6} sm={8} lg={6}>

                    <AddonDescriptionCard
                      key={selectedAddon.id}
                      selected={selectedAddon}
                      name={selectedAddon.name}
                      title={selectedAddon.title}
                      image={selectedAddon.image}
                      description={selectedAddon.description}
                      isActive={activeLicences.indexOf(selectedAddon.name) !== -1}
                      onSubscribeClick={(event) => handleSubscribleClick(event, selectedAddon.name)}
                      monthlyClubPrice={selectedAddon.monthlyClubPrice}
                      yearlyClubPrice={selectedAddon.yearlyClubPrice}
                    />


                  </Grid>}


              </Grid>

              <Dialog
                open={open}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleClose}
                aria-describedby="alert-dialog-slide-description"
              >
                <DialogTitle>{`Subscribe to "${selectedAddon.title}"?`}</DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-slide-description">
                    {selectedAddon.description}<br /><br />
                    Please select yearly or monthly
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <OutlinedButton
                    text={redirectLoading === 'monthly' ? <SectionSpinner smaller="true" /> : "Monthly"}
                    onClick={(event) => onSubscribeClick(event, selectedAddon.name, 'monthly')}
                    fullWidth
                  />
                  <OutlinedButton
                    text={redirectLoading === 'yearly' ? <SectionSpinner smaller="true" /> : "Yearly"}
                    onClick={(event) => onSubscribeClick(event, selectedAddon.name, 'yearly')}
                    fullWidth
                  />
                </DialogActions>
              </Dialog>
            </>
          }

        </MainWrapper >
      }
    </>
  );
};

export default Addons;
